import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import axios from 'axios';

import { fetchProducts } from '../../../actions/products_actions';
import { ROOT_URL } from '../../../actions/root_url';
import { isOCM, isOLG } from '../../../actions/root_url';

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function fetchProductsForIssueCredit(searchTerm, currentCustomer_id, companyid, type, success) {
  try {
    const url = `${ROOT_URL}v1/inventory/sales_order/search/${currentCustomer_id}/?${type}=${searchTerm}&Company_id=${companyid}`;
    axios({
      method: 'GET',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(res => {
      success(res.data.slice(0, 20));
    }).catch(err => {
    })
  } catch (err) {
  }
}
/* --------------- */
/*    Component    */
/* --------------- */

class IssueCreditAutoSuggest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      suggestions: [],
      noSuggestions: false,
    };

    this.lastRequestId = null;
    this.onSuggestionsFetchRequested = _.throttle(({ value }) => {
      this.fetchProductList(value);
    }, 200);
  }

  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  fetchProductList = (value) => {
    const success = (suggestions) => {
      this.setState({
        suggestions,
      });
    };
    fetchProductsForIssueCredit(value, this.props.currentCustomer_id, this.props.selectedCompany.value, this.props.SearchType, success)
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onFocus(event) {
    event.target.select();
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    // function to get product here
    event.stopPropagation();
    event.preventDefault();
    this.props.selectInventoryInfo(suggestion);
    if (isOCM) {
      this.props.fetchItemSalesHistory(this.props.currentCustomer_id, suggestion.Product_id, true);
    }
  }

  onKeyPress = () => {
    return false;
  }

  getSuggestionValue = (suggestion) => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;
      case 'GeneralNum':
        return `${suggestion.GeneralNum} | ${suggestion.Name}`;
      case 'Barcode':
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
      default:
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
    }
  }

  loadSuggestions(value) {
    this.setState({
      isLoading: true,
      suggestions: [],
    });
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.salesOrderSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  renderSuggestion = (suggestion) => {
    return <Row
      id="suggestion-render"
      className="sales-auto-suggest-suggestions"
      style={{ fontSize: isOLG ? '15px': '10px', fontWeight: 'bold' }}
    >
      {!isOLG && <Col xs={1}>
        {suggestion.ProductNum}
      </Col>}
      <Col xs={1}>
        {suggestion.RefNum}
      </Col>
      {!isOLG && <Col xs={2}>
        {suggestion.Name}
      </Col>}
      <Col xs={2}>
        {suggestion.Description}
      </Col>
      <Col xs={1} id="price-col">
        {suggestion.Price}
      </Col>
      <Col xs={1}>
        {suggestion.PackageType}
      </Col>
      <Col xs={1}>
        {suggestion.InStock}
      </Col>
      <Col xs={1}>
        {suggestion.Purchased}
      </Col>
      <Col xs={1}>
        {suggestion.PreSale}
      </Col>
    </Row>
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };
    return (
      <div {...restContainerProps} style={{ width: '150%', borderBottom: '1px solid grey' }}>
        <Row style={{ padding: '10px 5px', margin: '0px', fontWeight: 'bold' }}>
          {!isOLG && <Col xs={1}>
            <Translate value="prod_num" />
          </Col>}
          <Col xs={1}>
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </Col>
          {!isOLG && <Col xs={2}>
            <Translate value="prod_name" />
          </Col>}
          <Col xs={2}>
            <Translate value="desc" />
          </Col>
          <Col xs={1}>
            <Translate value="unit_price" />
          </Col>
          <Col xs={1}>
            <Translate value="package_type" />
          </Col>
          <Col xs={1}>
            <Translate value="in_stock" />
          </Col>
          <Col xs={1}>
            <Translate value="purchased" />
          </Col>
          <Col xs={1}>
            <Translate value="presale" />
          </Col>
        </Row>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    )
  }

  render() {
    const { suggestions } = this.state;
    const { SearchType } = this.props;
    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'issue-credit-auto-suggest',
    };
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        onSuggestionSelected={this.onSuggestionSelected}
        inputProps={inputProps}
        focusInputOnSuggestionClick={false}
        highlightFirstSuggestion
      />
    );
  }
}

export default IssueCreditAutoSuggest;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/components/IssueCreditAutoSuggest.jsx